var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M10.8057205,5.22848662 L6.36751215,9.78635015 C6.22935781,9.92878338 6.05666487,10 5.88397195,10 C5.71127901,10 5.52131679,9.92878338 5.40043175,9.78635015 L3.20723152,7.54302669 C2.93092283,7.25816023 2.93092283,6.81305636 3.20723152,6.52818989 C3.4835402,6.24332342 3.91527254,6.24332342 4.19158122,6.52818989 L5.88397195,8.27299703 L9.82137075,4.21364985 C10.0976794,3.92878338 10.5294118,3.92878338 10.8057205,4.21364985 C11.0647598,4.49851632 11.0647598,4.96142432 10.8057205,5.22848662 Z",
    transform: "translate(-3 -3.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.3d9701685fbbc25044eabff0e9a1a704.svg";
export { ForwardRef as ReactComponent };